import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import productService from "../services/Products.Service";

    export const saveDetails = createAsyncThunk("/product/save", async (params, thunkAPI)=>{
        try{
            const data = await productService.create(params);
            return data.data;
        }catch(exception){
            console.log(exception.response)
            if (typeof exception.response === "undefined") {
                return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    
    });

    export const getList = createAsyncThunk("/product/list", async (params, thunkAPI)=>{
        try{
            let pageData =  Object.assign({}, params.data)
            //pageData.page = pageData.page - 1  
            const data = await productService.fatch(pageData);
            return data.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    });

    export const getProductById = createAsyncThunk("/productId", async (productId, thunkAPI)=>{
        try{
            const data = await productService.getProductById(productId);
            return data.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    });

    const initialState = {
        list:[],
        totalData:0,
        editData:{},
        errors:false,
        success:false,
        loading:false,
        message:"",
    }
    
    const products = createSlice({
        name : "products",
        initialState,
        reducers:{
            reset:(state,action) =>{
                if(Object.keys(action.payload) > 0){
                return {
                    ...initialState,
                    ...action.payload
                }
                }else{
                return  initialState
                }
                
            },
            resetApiStatus:(state) => {
                return {
                    ...initialState,
                    errors:false,
                    success:false,
                    loading:false,
                    message:false
                }
            },
            checkGoods: ()=>{
                console.log("Goods Check")
            },
            setEditData:(state, action)=>{
                console.log(action.payload.id)
                const data = state.list.find( (item) => {
                    console.log(item)
                    return  item._id === action.payload.id
                } )    
                console.log(data)
            }
        },
        extraReducers: {
            [saveDetails.pending] : (state) => {
                state.loading = true
                state.errors = false
                state.success = false
            },
            [saveDetails.fulfilled] : (state, action) => {
                state.loading = false;
                const data = action.payload
                state.message = data.msg;    
                state.success = true
                // if(data.status === "failed"){
                //     state.success = false
                //     state.message = data.message;    
                    
                // }else{
                //     state.success = true
                //     state.message = data.message; 
                // }
            },    
            [saveDetails.rejected] : (state, action) => {
                console.log(action.payload)
                state.loading = false;
                state.success = false
                state.message = action.payload.errors;  
            },
            
            [getList.pending] : (state) => {
                state.loading = true
                state.errors = false
                state.success = false
            },
            [getList.fulfilled] : (state, action) => {
                state.loading = false;
                state.list = action.payload.docs
                state.totalCount = action.payload.totalDocs
            },    
            [getList.rejected] : (state, action) => {
                state.loading = false;
                state.success = false
                state.message = action.payload.message;    
            },

            [getProductById.pending] : (state) => {
                state.loading = true
                state.errors = false
                state.success = false
            },
            [getProductById.fulfilled] : (state, action) => {
                state.loading = false;
                state.editData = action.payload.data
            },    
            [getProductById.rejected] : (state, action) => {
                state.loading = false;
                state.success = false
                state.message = action.payload.message;    
            }
        }
    
    })
    export const { reset, resetApiStatus, setEditData } = products.actions;
    export default products.reducer 